<template>
    <div id="api-detail">
        <div class="row-block block-1" id="blk-1">
            <div class="block-inner">
                <div class="block-title">
                    <h2>功能介绍</h2>
                </div>
                <div class="block-1-content">
                    <div class="item">
                        <div class="item-icon">
                            <div class="icon-animation icon1">
                                <img src="../assets/images/icon.png"/>
                            </div>
                        </div>
                        <div class="line"></div>
                        <h3>金融事件识别</h3>
                        <p>
                            能够识别新闻和公告中13种常见的金融事件类型
                        </p>
                    </div>
                    <div class="item">
                        <div class="item-icon">
                            <div class="icon-animation icon1">
                                <img src="../assets/images/icon.png"/>
                            </div>
                        </div>
                        <div class="line"></div>
                        <h3>事件要素抽取</h3>
                        <p>
                            可以精准解析事件类型、角色
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row-block viewBox">
            <h2>功能体验</h2>
            <div id="extract-frame">
                <Extract/>
            </div>
        </div>

        <div class="row-block block-1 block-2" id="blk-2">
            <div class="block-inner">
                <div class="block-title">
                    <h2>产品优势</h2>
                </div>
                <div class="block-1-content block-2-content">
                    <div class="item">
                        <div class="item-icon">
                            <div class="icon-animation icon1">
                                <a href="/"><img src="../assets/images/icon.png"/></a>
                            </div>
                        </div>
                        <div class="line"></div>
                        <h3>篇章中单一事件识别</h3>
                        <p></p>
                    </div>
                    <div class="item">
                        <div class="item-icon">
                            <div class="icon-animation icon1">
                                <a href="/"><img src="../assets/images/icon.png"/></a>
                            </div>
                        </div>
                        <div class="line"></div>
                        <h3>篇章中多个事件，且角色不重合识别</h3>
                        <p></p>
                    </div>
                    <div class="item">
                        <div class="item-icon">
                            <div class="icon-animation icon1">
                                <img src="../assets/images/icon.png"/>
                            </div>
                        </div>
                        <div class="line"></div>
                        <h3>篇章中多个事件，不同事件中同一实体可能扮演不同的角色识别</h3>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Extract from './Extract.vue'

    export default {
        name: 'Detail',
        components: {
            Extract
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#api-detail img {
	height: 96%;
	width: 96%;
}
#extract-frame {
    width: 1128;
    height: 380;
    display: inline-block;
    border: 1px solid #FF9000
}
</style>